<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import { Toaster } from '@/components/ui/toast'
import { trackingConsentBannerOpen } from '@/practice/trackingConsent'

// Loaded only when the banner opens, so visitors who never see it download nothing extra.
const TrackingConsentBanner = defineAsyncComponent(() => import('@/components/TrackingConsentBanner.vue'))
</script>
<template>
  <RouterView />
  <Toaster/>
  <TrackingConsentBanner v-if="trackingConsentBannerOpen" />
</template>
